export default function FinalCTA() {
  return (
    <section className="bg-[#1A365D] py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">Get Started Today</p>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-5">
          Get Your Rapid City Passport in as Few as 2 Days
        </h2>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Skip the 360-mile trip to Denver. Fast Passport Center handles your Rapid City passport application from start to finish — with a dedicated agent, daily updates, and as-fast-as-2-day processing.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Passport Application <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white font-semibold text-base px-8 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto">
          {[
            { icon: "ri-timer-line", label: "As Fast as 2 Days" },
            { icon: "ri-user-star-line", label: "Dedicated Agent" },
            { icon: "ri-shield-check-line", label: "A+ BBB Rating" },
            { icon: "ri-map-pin-line", label: "No Denver Trip" },
          ].map((stat, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10">
                <i className={`${stat.icon} text-[#F6C344] text-lg`}></i>
              </div>
              <p className="text-white/70 text-xs font-semibold text-center">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}